import { lightGreen, microGreen } from '@/styles/theme/colors'
import type { ColorScheme } from '@/styles/theme/types'

export const logoColors = {
	dark: 'light',
	light: 'dark',
} as Record<ColorScheme, 'dark' | 'light'>

const commonNavColorStyles = {
	dark: {
		'--NavGroup-title-color': 'var(--mui-palette-neutral-400)',
		'--NavItem-color': 'var(--mui-palette-neutral-300)',
		'--NavItem-hover-background': 'var(--mui-palette-action-hover)',
		'--NavItem-active-background': lightGreen[200],
		'--NavItem-active-color': microGreen[900],
		'--NavItem-disabled-color': 'var(--mui-palette-neutral-500)',
		'--NavItem-icon-color': 'var(--mui-palette-neutral-400)',
		'--NavItem-icon-active-color': microGreen[900],
		'--NavItem-icon-disabled-color': 'var(--mui-palette-neutral-600)',
		'--NavItem-expand-color': 'var(--mui-palette-neutral-400)',
		'--NavItem-children-border': 'var(--mui-palette-neutral-700)',
		'--NavItem-children-indicator': 'var(--mui-palette-neutral-400)',
		'--Workspaces-background': 'var(--mui-palette-neutral-950)',
		'--Workspaces-border-color': 'var(--mui-palette-neutral-700)',
		'--Workspaces-title-color': 'var(--mui-palette-neutral-400)',
		'--Workspaces-name-color': 'var(--mui-palette-neutral-300)',
		'--Workspaces-expand-color': 'var(--mui-palette-neutral-400)',
	},
	light: {
		'--NavGroup-title-color': 'var(--mui-palette-neutral-600)',
		'--NavItem-color': 'var(--mui-palette-neutral-600)',
		'--NavItem-hover-background': 'var(--mui-palette-action-hover)',
		'--NavItem-active-background': lightGreen[200],
		'--NavItem-active-color': microGreen[900],
		'--NavItem-disabled-color': 'var(--mui-palette-neutral-400)',
		'--NavItem-icon-color': 'var(--mui-palette-neutral-500)',
		'--NavItem-icon-active-color': microGreen[900],
		'--NavItem-icon-disabled-color': 'var(--mui-palette-neutral-500)',
		'--NavItem-expand-color': 'var(--mui-palette-neutral-500)',
		'--NavItem-children-border': 'var(--mui-palette-neutral-200)',
		'--NavItem-children-indicator': 'var(--mui-palette-neutral-500)',
		'--Workspaces-background': 'var(--mui-palette-neutral-100)',
		'--Workspaces-border-color': 'var(--mui-palette-divider)',
		'--Workspaces-title-color': 'var(--mui-palette-neutra-400)',
		'--Workspaces-name-color': 'var(--mui-palette-neutral-900)',
		'--Workspaces-expand-color': 'var(--mui-palette-neutral-400)',
	},
}

export const sideNavColorStyles = {
	dark: {
		'--SideNav-background': 'var(--mui-palette-background-default)',
		'--SideNav-color': 'var(--mui-palette-common-white)',
		'--SideNav-border': '1px solid var(--mui-palette-neutral-700)',
		...commonNavColorStyles.dark,
	},
	light: {
		'--SideNav-background': 'var(--mui-palette-background-default)',
		'--SideNav-color': 'var(--mui-palette-text-primary)',
		'--SideNav-border': '1px solid var(--mui-palette-divider)',
		...commonNavColorStyles.light,
	},
} satisfies Record<ColorScheme, Record<string, string>>

export const mobileNavColorStyles = {
	dark: {
		'--MobileNav-background': 'var(--mui-palette-background-default)',
		'--MobileNav-color': 'var(--mui-palette-common-white)',
		...commonNavColorStyles.dark,
	},
	light: {
		'--MobileNav-background': 'var(--mui-palette-background-default)',
		'--MobileNav-color': 'var(--mui-palette-text-primary)',
		...commonNavColorStyles.light,
	},
} satisfies Record<ColorScheme, Record<string, string>>
